export default "__VITE_ASSET__Dh03_dYm__"